// https://github.com/developit/mitt/blob/main/README.md#usage
import mitt from 'mitt';
import type { Emitter } from 'mitt';
import type { PaginationEvents } from '$shared/inline-pagination/inlinePaginationEvents' 
import type { TabEvents } from '$shared/tabs/tabEvents';

export type Events = PaginationEvents & TabEvents;

export const eventBus: Emitter<Events> = mitt<Events>();